import { useMutation } from '@tanstack/vue-query';
import { getPfmInstance } from '@shared/api';
import { Sentry } from '@shared/sentry';
import { getUtmParams } from '@shared/lib/utm-lib';
import type { RequestPayload } from '../types';

const withAnalyticsUtmTags = (payload: RequestPayload) => {
  const utmParams = getUtmParams();

  return {
    ...payload,
    analytics: utmParams,
  };
};

const createRequest = (requestPayload: RequestPayload) => {
  const pfm = getPfmInstance();
  const data = withAnalyticsUtmTags(requestPayload);
  return pfm.tourflow.createRequest(data);
};

export const useCreateRequest = () => {
  const { mutateAsync, isLoading, isSuccess, isError, reset } = useMutation({
    mutationFn: createRequest,
  });

  const create = (requestPayload: RequestPayload) => {
    mutateAsync(requestPayload).catch(error => {
      Sentry.captureExWithCause('ERR_FAILED_TO_CREATE_REQUEST', {
        cause: error,
        captureContext: {
          extra: {
            errors: error.response?.data?.errors,
          },
        },
      });
    });
  };

  return {
    create,
    reset,
    isLoading,
    isSuccess,
    isError,
  };
};
